import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import '../Components/text.css';

function Footer() {
  return (
    <div style={{ display: 'flex', width: '75%', marginTop: '3%', justifyContent: 'center', flexDirection: 'column' }}>
      <div style={{ display: 'flex', marginTop: '3%', justifyContent: 'space-around' }}>
        <Link to="/PrivacyPolicy" className='lighttext'>Privacy Policy</Link>
        <Link to="/TermsOfServices" className='lighttext'>Terms of Services</Link>
        <Link to="/ContactUs" className='lighttext'>Contact Us</Link>
      </div>
      <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', flexDirection: 'column' }}>
        <div style={{ display: 'flex', marginTop: '3%', flexDirection: 'row', justifyContent: 'center', gap: '10px' }}>
          <a href="https://x.com/WaterSprintUK" target="_blank" rel="noopener noreferrer">
            <button>
              <FontAwesomeIcon icon={faTwitter} style={{ color: '#4F9685' }} size="2x" />
            </button>
          </a>
          <a href="https://www.linkedin.com/in/watersprint-uk-589a13382" target="_blank" rel="noopener noreferrer">
            <button>
              <FontAwesomeIcon icon={faLinkedin} size="2x" style={{ color: '#4F9685' }} />
            </button>
          </a>
          <a href="https://www.instagram.com/watersprint.uk" target="_blank" rel="noopener noreferrer">
            <button>
              <FontAwesomeIcon icon={faInstagram} style={{ color: '#4F9685' }} size="2x" />
            </button>
          </a>
        </div>
        <div style={{ marginTop: '1%' }}>
          <p className='lighttext'>© 2024 WaterSprint. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;